import ChildSessionsGrid from './ChildSessionsGrid'
import ChildSessionsGridItem from './ChildSessionsGridItem'
import ChildSessionsGridButtonItem from './ChildSessionsGridButtonItem'

ChildSessionsGrid.Item = ChildSessionsGridItem
ChildSessionsGrid.ButtonItem = ChildSessionsGridButtonItem

export default ChildSessionsGrid
